import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function SeniorSoftwareEngineerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["senior-software-engineer"]} />;
}
